<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('settingsPages.generalSettings')" class="text-left">
              <settings-general v-if="isGeneralSettings" :isGeneralSettings="isGeneralSettings"></settings-general>
            </v-tab>
            <v-tab :title="$t('deliveryPreferences.deliveryTypeTitle')" class="text-left">
              <settings-delivery-type v-if="isDeliveryType"></settings-delivery-type>
            </v-tab>
            <v-tab :title="$t('settingsPages.locationSettings')" class="text-left">
              <settings-locations v-if="isLocationSettings" :isLocationSettings="isLocationSettings"></settings-locations>
            </v-tab>
            <v-tab :title="$t('pages.payment')" class="text-left">
              <payment v-if="isPayment" :isPayment="isPayment"></payment>
            </v-tab>
            <!-- <v-tab :title="$t('settingsPages.moduleManager')" class="text-left">
              <settings-modules v-if="isModuleManager" :isModuleManager="isModuleManager"></settings-modules>
            </v-tab> -->
            <v-tab :title="$t('settingsPages.integrations')" class="text-left">
              <settings-integrations v-if="isIntegrations" :isIntegrations="isIntegrations"></settings-integrations>
            </v-tab>
            <v-tab title="Taxe" class="text-left">
              <taxes-v2 v-if="isTaxes"></taxes-v2>
            </v-tab>
            <v-tab :title="$t('settingsPages.fiscalPrinter')" class="text-left">
              <fiscal-printer-list v-if="isFiscalPrinter" :isFiscalPrinter="isFiscalPrinter"></fiscal-printer-list>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import SettingsGeneral from 'src/components/Dashboard/Views/Settings/SettingsGeneral.vue'
  import SettingsLocations from 'src/components/Dashboard/Views/Settings/SettingsLocations.vue'
  import Payment from 'src/components/Dashboard/Views/Payment/Payment.vue'
  import SettingsModules from 'src/components/Dashboard/Views/Settings/SettingsModules.vue'
  import SettingsIntegrations from 'src/components/Dashboard/Views/Settings/SettingsIntegrations.vue'
  import SettingsDeliveryType from 'src/components/Dashboard/Views/Settings/DeliveryPreferences/SettingsDeliveryType.vue'
  import TaxesV2 from 'src/components/Dashboard/Views/Settings/TaxesV2.vue'
  import FiscalPrinterList from 'src/components/Dashboard/Views/PosSettings/FiscalPrinterList.vue'

  export default {
    components: {
      SettingsGeneral,
      SettingsLocations,
      Payment,
      SettingsModules,
      SettingsIntegrations,
      SettingsDeliveryType,
      TaxesV2,
      FiscalPrinterList
    },
    data () {
      return {
        isGeneralSettings: false,
        isLocationSettings: false,
        isModuleManager: false,
        isPayment: false,
        isIntegrations: false,
        isDeliveryType: false,
        isTaxes: false,
        isFiscalPrinter: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isGeneralSettings = false
        this.isLocationSettings = false
        this.isModuleManager = false
        this.isPayment = false
        this.isIntegrations = false
        this.isDeliveryType = false
        this.isTaxes = false
        this.isFiscalPrinter = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('settingsPages.generalSettings'):
            this.isGeneralSettings = true
            break
          case this.$t('deliveryPreferences.deliveryTypeTitle'):
            this.isDeliveryType = true
            break
          case this.$t('settingsPages.locationSettings'):
            this.isLocationSettings = true
            break
          case this.$t('settingsPages.moduleManager'):
            this.isModuleManager = true
            break
          case this.$t('pages.payment'):
            this.isPayment = true
            break
          case this.$t('settingsPages.integrations'):
            this.isIntegrations = true
            break
          case 'Taxe':
            this.isTaxes = true
            break
          case this.$t('settingsPages.fiscalPrinter'):
            this.isFiscalPrinter = true
            break
          default:
            this.isGeneralSettings = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsSidebar.vue